import { Tab } from 'components/core-v2/atoms/tab'
import { FC } from 'react'
import { ClassName } from 'types/props'

import { SimpleTabStrip } from '../simple-tab-strip'

interface PanelProps extends ClassName {
  value: string
}
const Panel: FC<PanelProps> = ({ children, className, value }) => (
  <div aria-labelledby={`${value}-tab`} className={className} id={`${value}-panel`} role="tabpanel">
    {children}
  </div>
)

export const Tabs = {
  Tab,
  List: SimpleTabStrip,
  Panel
}
